import AssociationType from "@/models/Customers/Associations/AssociationType";

export default (value: AssociationType) => {
   switch(value) {
      case AssociationType.Director: {
         return "Director";
      }
      case AssociationType.Trustee: {
         return "Trustee";
      }
      case AssociationType.Beneficiary: {
         return "Beneficiary";
      }
      case AssociationType.Shareholder: {
         return "Shareholder";
      }
      default: {
         return "Unknown entity type";
      }
   }
}